module.exports = __webpack_public_path__ + "media/images/smart_phone/ranking-304265a75b44f3e6cf96b71c21cabea6.png";